<template>
  <div id="app">
    <v-app id="inspire" class="page">
      <v-navigation-drawer
        app
        fixed
        class="noprint d-print-none"
        :clipped="$vuetify.breakpoint.mdAndUp"
        v-model="drawer"
        v-if="user.fullName != ''"
      >
        <MyMenu />

          <div class="menu-logo">
              <img
                style="max-width: 40%;"
                :src="require('@/assets/colour-logo-transparent-bg.png')"
              />
              <div style="font-size: 10px">Copyright Vindico 2019 ©</div>
          </div>
      </v-navigation-drawer>

      <v-toolbar clipped-left dark class="noprint primary" fixed app v-if="user.fullName != ''">
        <v-toolbar-side-icon v-if="hide" @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <img
          :src="require('@/assets/white-logo-transparent-bg.png')"
          style="max-width: 140px"
          class="ml-2"
        />
        <v-spacer></v-spacer>
        <v-icon right medium class="icons8-full-screen" @click="toggleFullscreen"></v-icon>
        <v-icon right medium class="icons8-gender-neutral-user" @click="login"></v-icon>

        <div>
          <v-select
            v-if="portal.active.id === null"
            v-model="currentPortal"
            class="mt-1"
            style="max-height: 50px !important; max-width: 200px !important; border: 0px solid white !important;"
            :items="portalList"
            return-object
            label="Choose a Portal"
            @change="portalDialog = false"
          >
            <template slot="item" slot-scope="data">{{ data.item.name }}</template>
            <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
          </v-select>
        </div>
      </v-toolbar>
      <v-content>
        <router-view @navOpen="drawer = $event" />

        <InstallPrompt></InstallPrompt>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MyMenu from "@/components/Menu.vue";
import InstallPrompt from "@/components/InstallPrompt";

export default {
  name: "App",
  components: {
    MyMenu,
    InstallPrompt
  },
  data: () => ({
    drawer: null,
    isFullscreen: false,
    clipped: true
  }),
  computed: {
    ...mapState({
      user: state => state.user.active,
      portal: state => state.portal,
      Menu: state => state.Menu
    }),
    hide() {
      return (
        this.$route.path !== "/authentication/login" &&
        this.$route.path !== "/authentication/signup" &&
        this.$route.path !== "/"
      );
    }
  },
  methods: {
    login: function() {
      if (this.user.userID != 0) this.$router.push("/user-profile");
      else this.$router.push("/authentication/login");
    },
    changeColor() {
      this.$store.commit("portal/setActiveValue", ["name", "Add Clarity"]);
    },
    toggleFullscreen: function(event) {
      var elem = document.documentElement;
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        if (!this.isFullscreen) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
            this.isFullscreen = true;
            return;
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
            this.isFullscreen = true;
            return;
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            this.isFullscreen = false;
            return;
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
            this.isFullscreen = false;
            return;
          }
        }
      }
    }
  },
  created() {
    var v = this;
    var origin, domainURL;
    if (window.location.hostname === "localhost") {
      origin = "https://functions.addclarity.net";
      domainURL = "demo.addclarity.net";
    } else {
      origin = window.location.origin;
      domainURL = window.location.hostname;
    }
    this.$axios
      .get(origin + "/functions/getPortal?domainURL=" + domainURL)
      .then(response => {
        v.$vuetify.theme.page = response.data.result.page;
        v.$vuetify.theme.card = response.data.result.card;
        v.$vuetify.theme.primary = response.data.result.primary;
        v.$vuetify.theme.secondary = response.data.result.secondary;
        v.$vuetify.theme.info = response.data.result.info;
        v.$vuetify.theme.error = response.data.result.error;
        v.$vuetify.theme.success = response.data.result.success;
        v.$vuetify.theme.footer = response.data.result.footer;
        v.$vuetify.theme.warning = response.data.result.warning;
        setTimeout(function() {
          v.$store.commit("portal/setActive", response.data.result);
        }, 3000);
      });
  },
  mounted() {
    //console.log("primary = ", this.portal.active.primary)
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
    this.$store.dispatch("integration/readIntegrations");
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.acbutton {
  border-radius: 10px !important;
}
.pagemargin {
  margin-top: 0px !important;
}

.menu-logo {
  position: absolute;
  bottom: 0 !important;
}
@media print and (max-width: 600px) {
  .noprint {
    display: none !important;
    clear: both !important;
  }
  .d-print-none {
    display: none !important;
  }
}
</style>